import _ from 'lodash';

export interface IErrorPayload {
    trace_id?: string;
    code?: string;
    message?: string;
    errors?: string;
    url?: string;
    hideTrace?: boolean;
    /** Demo mode refused the request before it was sent — see `DialogProvider`. */
    demoBlocked?: boolean;
}

export const stream2string = async (readableStream: ReadableStream): Promise<string> => {
    const reader = readableStream.getReader();
    const chunks: string[] = [];
    function pump(): Promise<string[]> {
        return reader.read().then(({ value, done }) => {
            if (done) {
                return chunks;
            }
            const s: string[] = _.map(value, (v: number): string => String.fromCharCode(v));
            chunks.push(s.join(''));
            return pump();
        });
    }
    await pump();
    return chunks.join('');
};

export const parseError = async (err: any): Promise<any> => {
    if (err.payload) {
        // do nothing, payload already available
    } else if (err && err.body && !err.bodyUsed) {
        const str: string = await stream2string(err.body);
        err.payload = JSON.parse(str);
    } else {
        err.payload = {
            message: err.message,
        };
    }
    // also transfer the URL to payload
    if (!err.payload.url) {
        err.payload.url = err.url;
    }
    return err;
};
